export const campus_map_keys=[
    {
        id:'1',
        place:'Sangamam Building'
    },
    {
        id:'2',
        place:'Placement Cell'
    },
    {
        id:'3',
        place:'Computer Centre'
    },
    {
        id:'4',
        place:'Murugappa Hall'
    },
    {
        id:'5',
        place:'Bus Shed'
    },
    {
        id:'6',
        place:'Library'
    },
    {
        id:'7',
        place:'ECE Block'
    },
    {
        id:'8',
        place:'CSE Block'
    },
    {
        id:'9',
        place:'Mechanical Laboratories'
    },
    {
        id:'10',
        place:'Mechanical Department (WS)'
    },
    {
        id:'11',
        place:'Mechanical CAD Lab'
    },
    {
        id:'12',
        place:'Mechanical Department (Lab)'
    },
    {
        id:'13',
        place:'Anna University Zonal Office'
    },
    {
        id:'14',
        place:'Science Block'
    },
    {
        id:'15',
        place:'EEE Block - I(C & I)'
    },
    {
        id:'16',
        place:'EEE Block-II (Power)'
    },
    {
        id:'17',
        place:'COE Office'
    },
    {
        id:'18',
        place:'Civil & EEE Block'
    },
    {
        id:'19',
        place:'Civil Block'
    },
    {
        id:'20',
        place:'Open Auditorium'
    },
    {
        id:'21',
        place:'Structural Engineering Lab'
    },
    {
        id:'22',
        place:'Canteen'
    },
    {
        id:'23',
        place:'Basket Ball Court'
    },
    {
        id:'24',
        place:'Tennis Court'
    },
    {
        id:'25',
        place:'Gym'
    },
    {
        id:'26',
        place:'Main Building'
    },
    {
        id:'27',
        place:'Indoor Stadium'
    },
    {
        id:'28',
        place:'NRSC Building'
    },
    {
        id:'29',
        place:'Parking Area'
    },
    {
        id:'30',
        place:'ATM'
    },
    {
        id:'31',
        place:'Incubation Centre'
    },
    {
        id:'32',
        place:'Rest rooms'
    },
    {
        id:'33',
        place:'E-Yantra Lab'
    },
    {
        id:'34',
        place:'Power House'
    },
    {
        id:'35',
        place:'Handball court'
    },
    {
        id:'36',
        place:'Kho-Kho'
    },
    {
        id:'37',
        place:'Volley Ball'
    },
    {
        id:'38',
        place:'Kabadi'
    },
    {
        id:'39',
        place:'New Indoor Stadium'
    },
    {
        id:'40',
        place:'Footbal Ground'
    },
    {
        id:'41',
        place:'Playground'
    },
    {
        id:'42',
        place:'Wifi-Tree'
    },
    {
        id:'43',
        place:'Build Club'
    },
    {
        id:'44',
        place:'Flag Post'
    },
    {
        id:'45',
        place:'Examination Hall'
    },
    {
        id:'46',
        place:'Training and Placement Centre(Saaral)'
    },
    {
        id:'47',
        place:'EEE Classrooms'
    },
    
]